import { combineReducers } from 'redux';
import userPreferences from 'app/userPreferences/slices';
import settings from 'app/settings/slices';

import auth from 'app/auth/slices'; // new slice
import dashboard from 'features/dashboard/slices'; // new slice
import { baseApi } from 'services/baseApi';
import resource from 'app/resource/slices';
import { resetAppState } from 'store/actions';
import player from './playerReducer';
import brands from './brandReducer';
import brandSetting from './brandSettingReducer';
import notification from './notificationReducer';
import template from './templateReducer';
import game from './gameReducer';
import promoCode from './promoCodeReducer';
import bonus from './bonusReducer';
import thirdPartyServices from './thirdPartyServicesReducer';
import cashBack from './cashBackReducer';
import referral from './referralReducer';
import blacklist from './blacklistReducer';
import tag from './tagReducer';
import brandPayment from './brandPaymentReducer';
import reporting from './reportingReducer';
import operatorLimit from './operatorLimitReducer';
import legalAgreement from './legalAgreementReducer';
import accountUpdate from './accountUpdateReducer';
import cashier from './cashierReducer';
import playerPerformance from './playerPerformanceReducer';
import systemConversion from './systemConversionReducer';
import overview from './overviewReducer';
import campaign from './campaignReducer';
import previousAccount from './previousAccountReducer';
import reasons from './reasonsReducer';
import taxes from './taxesReducer';
import brandMarket from './brandMarketReducer';
import exportCenter from './exportCenterReducer';
import playerWallet from './playerWalletReducer';
import playerSession from './playerSessionReducer';
import campaignV2 from './campaignV2Reducer';
import systemSetting from './systemSettingReducer';
import userActions from './userActionsReducer';
import superiorCountries from './superiorCountriesReducer';

const appReducer = combineReducers({
  player,
  brands,
  brandSetting,
  brandMarket,
  notification,
  template,
  game,
  promoCode,
  bonus,
  thirdPartyServices,
  cashBack,
  referral,
  blacklist,
  tag,
  brandPayment,
  reporting,
  operatorLimit,
  legalAgreement,
  accountUpdate,
  cashier,
  playerPerformance,
  dashboard,
  systemConversion,
  overview,
  previousAccount,
  reasons,
  campaign,
  taxes,
  exportCenter,
  playerWallet,
  playerSession,
  campaignV2,
  systemSetting,
  userActions,
  superiorCountries,
  [baseApi.reducerPath]: baseApi.reducer,
  auth,
  userPreferences,
  settings,
  resource,
});

const rootReducer = (state, action) => {
  if (resetAppState.match(action)) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
